if (!customElements.get('vbb-variant-selector-reactive')) {
  customElements.define('vbb-variant-selector-reactive', class VariantSelector extends HTMLElement {
    constructor() {
      super();

      this.rootUrl = this.dataset.rootUrl;
      this.productHandle = this.dataset.productHandle;
      this.inProductCard = this.dataset.inProductCard === 'true';
      this.options = this.querySelectorAll('ul[data-option]');
      this.variantLinks = this.querySelectorAll('a');
      this.activeVariantId = this.dataset.activeVariantId;

      this.historyUpdate = this.dataset.preventHistoryUpdate !== 'true';
      this.container = this.dataset.container || 'vbb-product-form-reactive';
      this.productForm = this.closest(this.container);
      this.productFormId = this.productForm.id;
      this.input = this.querySelector('input[type="hidden"]');
      this.setupEventListeners();
      this.setupFilterEventListeners()
    }

    setupEventListeners() {
      this.variantLinks.forEach(variantLink => {
        variantLink.addEventListener('click', e => {
          this.updateVariant(e, variantLink);
        });
        variantLink.addEventListener('mouseenter', e => {
          const listItem = variantLink.closest('li[data-variant-id]');
          const optionValue = listItem.dataset.variantId;
          this.updateLabel(optionValue)
        });
        variantLink.addEventListener('mouseleave', e => {
          this.updateLabel(this.activeVariantId)
        });
      });
    }

    setupFilterEventListeners() {
      this.filters = this.querySelectorAll('.js-variant-filter');
      this.filterToggles = this.querySelectorAll('.js-filter-toggle');
      this.filterGroupItems = this.querySelectorAll('.js-filter-group li');

      // Handle variant filter buttons (e.g., "light", "dark", etc.)
      if (this.filters.length > 0) {
        this.filters.forEach(filter => {
          filter.addEventListener('click', () => {
            const filterValue = filter.dataset.filter;
            this.dataset.filter = filterValue;

            this.filters.forEach(f => f.classList.remove('active'));
            filter.classList.add('active');
          });
        });
      }

      this.querySelectorAll('.vbb-variant-selector__filters--parent button').forEach(button => {
        button.addEventListener('click', () => {
          // Remove .active from all buttons
          this.querySelectorAll('.vbb-variant-selector__filters--parent button').forEach(btn => {
            btn.classList.remove('active');
          });

          // Add .active to the clicked button
          button.classList.add('active');

          // Show the filter container
          const filterWrapper = this.querySelector('.vbb-variant-selector__filters');
          filterWrapper.style.display = 'block';

          const targetFilterParent = button.dataset.filterParent;
          let anyVisible = false;

          this.querySelectorAll('.js-filter-group li').forEach(li => {
            const liGroup = li.dataset.filterParent;

            if (targetFilterParent === 'all') {
              li.classList.add('vbb-variant-selector__filters--hidden');
              filterWrapper.style.display = 'none';
            } else if (liGroup === targetFilterParent) {
              li.classList.remove('vbb-variant-selector__filters--hidden');
              anyVisible = true;
            } else {
              li.classList.add('vbb-variant-selector__filters--hidden');
            }

          });
        });
      });

    }



    updateVariant(e, variantLink) {
      e.preventDefault();
          const listItem = variantLink.closest('li[data-variant-id]');
          const optionName = listItem.dataset.optionName;
          const optionValue = listItem.dataset.optionValue;
          // Get all currently active options
          const activeOptions = Array.from(this.options).map(optionList => {
            const activeLi = optionList.querySelector(':scope [data-active="true"]');
            return activeLi.dataset.optionValue;
          });

          // Find index of the option being changed
          const optionIndex = Array.from(this.options).findIndex(
            list => list.dataset.option === optionName
          );

          // Update activeOptions with the newly selected value
          activeOptions[optionIndex] = optionValue;

          // Find the variant that matches all active options
          const newVariant = this.variantDetails.find(variant => {
            return JSON.stringify(variant.options) === JSON.stringify(activeOptions);
          });

          // Update active variant ID
          this.activeVariantId = newVariant?.variantId;

          // Update active states
          const optionList = listItem.closest('ul[data-option]');
          optionList.querySelectorAll('li[data-variant-id]').forEach(li => {
            li.dataset.active = (li === listItem);
          });

          // Maintain active variant. Loop through and turn all off unless it's the active one

          // Update all variant IDs and URLs
          this.options.forEach(optionList => {
            optionList.querySelectorAll('li[data-variant-id]').forEach(li => {
              const thisOptionName = li.dataset.optionName;
              const thisOptionValue = li.dataset.optionValue;

              // Create temporary options array for this combination
              const tempOptions = [...activeOptions];
              const thisOptionIndex = Array.from(this.options).findIndex(
                list => list.dataset.option === thisOptionName
              );
              tempOptions[thisOptionIndex] = thisOptionValue;

              // Find matching variant
              const matchingVariant = this.variantDetails.find(variant =>
                JSON.stringify(variant.options) === JSON.stringify(tempOptions)
              );

              // Update variant ID and URL
              if (matchingVariant) {
                li.dataset.variantId = matchingVariant.variantId;
                li.dataset.outOfStock = matchingVariant.inStock ? 'false' : 'true';
                li.disabled = matchingVariant.inStock ? false : true;
                if (this.historyUpdate) {
                  // This will need to be updated for non-pdps
                  const link = li.querySelector('a');
                  const url = `/products/${this.productHandle}?variant=${matchingVariant.variantId}`;
                  link.href = this.rootUrl !== '/' && this.rootUrl !== '/fr'
                    ? `${this.dataset.market}${url}`
                    : url;
                }
              }
            });
          });

          this.updateInput();
          this.updateLabel(this.activeVariantId);
          // Dispatch change event
          this.productForm.dispatchEvent(new CustomEvent('variant:selected', {
            detail: {
              productFormId: this.productFormId,
              variantId: this.activeVariantId,
            },
            bubbles: true,
            composed: true,
          }));
          // Update the URL if not in a product card
          if (this.historyUpdate) {
            this.updateHistoryState();
          }
    }
    updateInput(){
      // Update hidden input value
      this.input.value = this.activeVariantId;
    }

    updateLabel(variantId){
      variantId = parseInt(variantId)
      this.activeVariantLabel = this.querySelector('.js-variant-label');
      if(!variantId || !this.activeVariantLabel) return
      const swatchDescription = this.variantDetails.find(variant => variant?.variantId === variantId)?.swatchDescription ?? ''
      const swatchLabel = this.variantDetails.find(variant => variant?.variantId === variantId)?.title

      if(!swatchLabel) return;
      const swatchLabelHtml = `<span>${swatchLabel}</span>`
      this.activeVariantLabel.innerHTML = `${swatchLabelHtml} ${swatchDescription ? ` - ${swatchDescription}` : ''}`
    }

    updateHistoryState() {
      const state = { variantId: this.activeVariantId };
      let url = `/products/${this.productHandle}?variant=${this.activeVariantId}`;
      if (this.rootUrl !== '/' && this.rootUrl !== '/fr') {
        url = `${window.Shopify.routes.root}${url}`;
        // url = `${window.routes.market}${url}`;
      }

      // Remove any double slashes except for the protocol part (e.g., https://)
      url = url.replace(/([^:]\/)\/+/g, '$1');

      window.history.pushState(state, null, url);
    }

    // Set this up once on product form load?
    get variantDetails() {
      const variantData = this.productForm.querySelector(`#variant-details-${this.productFormId}`)?.textContent;
      if (!variantData) {
        console.warn('No variant data found');
        return [];
      }

      return JSON.parse(variantData);
    }
  });
}
